type TagPillProps = {
  label: string;
  className?: string;
  title?: string;
};

export function TagPill({ label, className, title }: TagPillProps) {
  const fullClassName = className ? `gitg-label ${className}` : "gitg-label";
  return (
    <span className={fullClassName} title={title}>
      {label}
    </span>
  );
}
